export default {
    apiKey: "AIzaSyCl5Vv0N-D9LW99PpqDLfXbamSLc1UBgeo",
    authDomain: "to-do-ef4c4.firebaseapp.com",
    databaseURL: "https://to-do-ef4c4.firebaseio.com",
    projectId: "to-do-ef4c4",
    storageBucket: "to-do-ef4c4.appspot.com",
    messagingSenderId: "603202874145",
    appId: "1:603202874145:web:51c2a1c0764ae9b3982c60",
    measurementId: "G-TQT1VZBNKD"
  };